import type { ReactNode } from 'react'
import { Button, Flex, Input, Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import type { LocalListState } from '@/shared/lib/localList'

interface ReportFilterBarProps {
  filter: Pick<LocalListState, 'searchText' | 'setSearchText' | 'narrowed' | 'reset'>
  searchPlaceholder: string
  /** Sahifaga MA'NOLI filtrlar (holat, tur, sinf) — sun'iysi qo'shilmaydi */
  extra?: ReactNode
  /** Jadvalda ko'rinayotgan qator soni */
  shown: number
  /** Serverdan kelgan qator soni (filtrsiz) */
  loaded: number
  /**
   * Filtr faol bo'lganda chiziladigan ogohlantirish — odatda «yakunlar
   * filtrga bog'liq emas». Yakuni yo'q jadvalda berilmaydi.
   */
  totalsNote?: string
}

/**
 * Hisobot jadvalining qidiruv qatori.
 *
 * ⚠️ Qidiruv KECHIKISH bilan URL'ga tushadi — kechikish `useLocalListState`
 * ichida, bu yerda emas: busiz har harf tarixga yozuv qo'shardi va
 * «orqaga» tugmasi o'nlab marta bosilishi kerak bo'lardi.
 *
 * ⚠️ «X / Y» soni ATAYLAB: filtr qo'yilganda operator nechta qator
 * YASHIRINGANINI ko'rishi kerak. Faqat qolgan sonni ko'rsatish
 * «hisobotda shuncha qator ekan» degan xato o'qishni berardi.
 */
export function ReportFilterBar({
  filter,
  searchPlaceholder,
  extra,
  shown,
  loaded,
  totalsNote,
}: ReportFilterBarProps) {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={8} style={{ marginBottom: 12 }}>
      <Flex align="center" justify="space-between" gap="small" wrap>
        <Space wrap>
          <Input.Search
            allowClear
            value={filter.searchText}
            onChange={(e) => filter.setSearchText(e.target.value)}
            placeholder={searchPlaceholder}
            style={{ width: 260, maxWidth: '100%' }}
          />
          {extra}
          {filter.narrowed ? (
            <Button type="link" size="small" onClick={filter.reset}>
              {t('dataTable.resetFilters')}
            </Button>
          ) : null}
        </Space>

        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {t('finance.reportTable.shown', { shown, loaded })}
        </Typography.Text>
      </Flex>

      {/* ⚠️ Faqat filtr FAOL bo'lganda: doim turgan ogohlantirish o'qilmay
          qoladi va keyin haqiqatan kerak bo'lganda ham ko'rinmaydi */}
      {filter.narrowed && totalsNote ? (
        <Typography.Text type="warning" style={{ fontSize: 12 }}>
          {totalsNote}
        </Typography.Text>
      ) : null}
    </Flex>
  )
}
